import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  connect () {
    this.toggle()
  }

  toggle () {
    this.inputTarget.toggleAttribute('data-filled', this.inputTarget.value !== '')
  }

  clear () {
    this.inputTarget.value = ''
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }
}
